/** @jsxImportSource @emotion/react */
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { activeCss, arrowCss, linkCss, listCss, rootCss } from "./index.css";

export default function Breadcrumbs({ breadcrumbs }) {
  return (
    <nav css={rootCss}>
      <ul css={listCss}>
        {breadcrumbs.map(({ label, path }, i) => (
          <li key={label} className="flex-a-c">
            {i > 0 && <span css={arrowCss} />}

            {path ? (
              <Link to={path} css={linkCss}>
                {label}
              </Link>
            ) : (
              <span css={activeCss}>{label}</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          pathname: PropTypes.string,
          search: PropTypes.string,
          hash: PropTypes.string,
        }),
      ]),
    }),
  ).isRequired,
};
